import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createRoom } from "../../redux/actions/room";
import Filter from "../Filter/Filter";
import { setMessage } from "../../redux/actions/auth";


const CreateRoom=(props)=>{
    const [filterCreate, setFilterCreate] = useState({});
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const roomSettings = useSelector(state => state.system.SettingsWallet);
    
    const dispatch =useDispatch();

    const selectClick=(e)=>{
        e.preventDefault();
        let arr = [];
        if(filterCreate.platform?.length>0){
            arr=[...filterCreate.platform]
        }
        let el = e.target.id;
        if (arr.indexOf(el) !== -1) {
            arr = arr.filter(item => item !== el);
        } else {
            arr.push(el);
        }
        setFilterCreate({
            ...filterCreate,
            platform: arr
        });
    }
    const resetFilterCreate=()=>{
        setFilterCreate({});
    }
    const createFunc =()=>{
        if (filterCreate.price < roomSettings?.minimumCost) {
            dispatch(setMessage({
                type: 'error',
                message: `Мінімальна вартість участі: ${roomSettings?.minimumCost}`,
            }))

            return;
        }

        let data = filterCreate;
        if(data.selectedGame){
        }else{
            data.selectedGame=props.game.id;
            data.termExistence=props.game.termExistence;
        }
        dispatch(createRoom(filterCreate)).then(res=>{
        })

        setIsOpenCreateClick();
    }
    const changeHandlerCreate = (e) => {
        const { id, value } = e.target;
        let updatedFilterCreate = { ...filterCreate };

        if (e.target.tagName === 'SELECT' && e.target.accessKey) {
            updatedFilterCreate[e.target.accessKey] = value;
        }
        else if (value.length<1) {
            delete updatedFilterCreate[id];
        }
        else if (id === 'isPrivateRoom') {
            if (e.target.checked === false) {
                updatedFilterCreate[id] = 0
            } else {
                updatedFilterCreate[id] = 1
            }
        }
        else {
            updatedFilterCreate[id] = value;
        }
        setFilterCreate(updatedFilterCreate);
    };
    const setIsOpenCreateClick=()=>{
        setIsOpenCreate(!isOpenCreate);
        props.setIsOpen(!isOpenCreate);
    }

    useEffect(() => {
        setIsOpenCreate(props.isOpen) 
       
    }, [props.isOpen]);

    return(
        <>
            {isOpenCreate && <Filter type='createRooms' game={props.game} selectClick={selectClick} needCheckedC={true} resetFilter={resetFilterCreate} accept={createFunc} filter={filterCreate} setFilter={setFilterCreate} onChange={changeHandlerCreate} isOpen={isOpenCreate} setIsOpen={setIsOpenCreateClick} />}
        </>
    )
}

export default CreateRoom;